import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const WaitlistPanel = ({ waitlistPatients, onScheduleFromWaitlist }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  if (waitlistPatients?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card border-t border-border">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between px-4 md:px-6 py-4 text-foreground transition-smooth hover:bg-muted"
      >
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-warning/10 rounded-lg">
            <Icon name="Clock" size={20} color="var(--color-warning)" />
          </div>
          <div className="text-left">
            <h3 className="font-semibold text-foreground">Waitlist</h3>
            <p className="text-sm text-muted-foreground">
              {waitlistPatients?.length} patient{waitlistPatients?.length !== 1 ? 's' : ''} waiting
            </p>
          </div>
        </div>
        <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={20} />
      </button>
      {isExpanded && (
        <div className="px-4 md:px-6 pb-4 space-y-3">
          {waitlistPatients?.map((patient) => (
            <div
              key={patient?.id}
              className="flex items-center gap-4 p-4 bg-muted rounded-lg transition-smooth hover:shadow-md"
            >
              <Image
                src={patient?.avatar}
                alt={patient?.avatarAlt}
                className="w-12 h-12 rounded-full object-cover flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-foreground truncate">{patient?.name}</h4>
                <p className="text-sm text-muted-foreground">MRN: {patient?.mrn}</p>
                <div className="flex items-center gap-4 mt-2 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={12} />
                    {patient?.preferredDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="User" size={12} />
                    {patient?.preferredProvider}
                  </span>
                </div>
              </div>
              <Button
                variant="outline"
                size="sm"
                iconName="Plus"
                iconPosition="left"
                onClick={() => onScheduleFromWaitlist(patient)}
              >
                Schedule
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WaitlistPanel;